const userRoles = {
  TENANTADMIN: Number(process.env.REACT_APP_TENANT_ADMIN_ROLE_ID),
  HR: Number(process.env.REACT_APP_HR_ROLE_ID),
  MANAGER: Number(process.env.REACT_APP_MANAGER_ROLE_ID),
  EMPLOYEE: Number(process.env.REACT_APP_EMPLOYEE_ROLE_ID),
  FINANCEADMIN: Number(process.env.REACT_APP_FINANCE_ADMIN_ROLE_ID),
};

export default userRoles;